import { Card, CardContent, IconButton, Typography } from '@volvo/vcdk-react';
import React from 'react';

import { common } from '@/utils';

export type TCard = {
  media: {
    src: string;
    alt: string;
  };
  link?: {
    href: string;
    target?: string;
    rel?: string;
  };
  label: string;
  title: string;
  body?: string;
};

interface ICardSectionProps {
  cards: TCard[];
  className?: string;
}

const CardSection: React.FC<ICardSectionProps> = ({ cards }) => {
  return (
    <>
      <div className="grid grid-cols-1 gap-8 px-8 md:grid-cols-2">
        {cards.map((card) => {
          const { link, media, label, title, body } = card;
          return (
            <Card key={common.slugify(title)} {...link}>
              <img src={media.src} alt={media.alt} />
              <CardContent>
                <div className="flex flex-col gap-4">
                  <Typography variant="caption1">{label} </Typography>
                  <Typography variant="heading3">{title}</Typography>
                  {!!body && (
                    <Typography variant="body" className="text-secondary">
                      {body}
                    </Typography>
                  )}
                  {!!link && <IconButton icon="arrow-right" {...link} />}
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </>
  );
};

export default CardSection;
